import mixpanel from '../../utilities/mixpanel';
import { FETCH_DOCUMENTS_SUCCESS } from '../modules/documents';
import { RETRIEVED_FILTERED_DOCUMENTS } from '../../constants/mixpanelEventNames';

const translateDocumentsResponse = store => next => action => {
  // we only want to translation the fetch documents success action payload
  if (action.type !== FETCH_DOCUMENTS_SUCCESS) {
    return next(action);
  }

  const documents = [];
  // This is filtering out documents that do not match these types
  const newTypeMappings = [
    {
      type: 'Customer Agreement',
      newType: 'Sunrun Agreement',
    },
    {
      type: 'Customer Change Order Cover Sheet',
      newType: 'Amendment to Sunrun Agreement ("Change Order")',
    },
    {
      type: 'EPC',
      newType: 'Construction Contract ("EPC")',
    },
    {
      type: 'NEM Agreement',
      newType: 'Utility Net Metering Agreement ("NEM")',
    },
    {
      type: 'Proposal',
      newType: 'Final Proposal',
    },
    {
      type: 'SOW - Electrical',
      newType: 'PTO Letter',
    },
    {
      type: 'Site Audit Printout',
      newType: 'Site Survey Results',
    },
    {
      type: 'Utility Bill',
      newType: 'Sample Utility Bill',
    },
    {
      type: 'Rebate Application',
      newType: 'Rebate Application',
    },
    {
      type: 'Rebate Application - Rebate Program',
      newType: 'Rebate Program Application',
    },
    {
      type: 'Rebate Reservation Conf.',
      newType: 'Rebate Reservation Confirmation',
    },
    {
      type: 'Design Image',
      newType: 'Charger Placement Design',
    },
    {
      type: 'EV Ford Agreement',
      newType: 'Ford Charger Agreement',
    },
    {
      type: 'CAP Package',
      newType: 'CAP Package',
    },
    {
      type: 'Renewal Addendum',
      newType: 'Renewal Addendum',
    },
  ];

  action.payload.forEach(doc => {
    // special cases for design plans, based on what the doc name is
    if (doc.type === 'Design Plans' && doc.name === 'design-plan.pdf') {
      documents.push({ ...doc, type: 'Design Plan' });
      return;
    }
    if (doc.type === 'Design Plans' && doc.name !== 'design-plan.pdf') {
      documents.push({ ...doc, type: 'Design Plan (Final)' });
      return;
    }

    // all other types
    newTypeMappings.forEach(mapping => {
      if (doc.type === mapping.type) {
        documents.push({ ...doc, type: mapping.newType });
      }
    });
  });

  // track number of documents from endpoint
  mixpanel.track(RETRIEVED_FILTERED_DOCUMENTS, { 'Document Count': documents.length });

  const newAction = {
    type: action.type,
    payload: documents,
  };
  return next(newAction);
};

export default translateDocumentsResponse;
